// @ts-ignore
import * as React from "react";
import { Button, Gapped, Tooltip } from "@skbkontur/react-ui";

export const spoilerSymbol = "░";

interface HiddenTextProps {
    length?: number;
    hinttext?: string;
    buttontext?: string;
    buttonlink?: string;
}

export const HiddenText = (props: HiddenTextProps) => {
    const tooltipButtonAction = () => {
        window.open(props.buttonlink, "_blank");
    };

    return (
        <Tooltip
            closeButton={true}
            allowedPositions={["top center", "top left", "bottom center", "bottom left"]}
            render={() => (
                <Gapped vertical gap={8} style={{ width: 240 }}>
                    {props.hinttext}
                    <Button use={"backless"} onClick={tooltipButtonAction} arrow>
                        {props.buttontext}
                    </Button>
                </Gapped>
            )}>
            <span data-tid={"DescriptionItemHiddenText"}>{spoilerSymbol.repeat(props?.length ?? 0)}</span>
        </Tooltip>
    );
};
